import { render, staticRenderFns } from "./AppRadioGroup.vue?vue&type=template&id=0617f356&scoped=true&"
import script from "./AppRadioGroup.vue?vue&type=script&lang=js&"
export * from "./AppRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./AppRadioGroup.vue?vue&type=style&index=0&id=0617f356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0617f356",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCol,VRadio,VRadioGroup})
